import styled from 'styled-components';

export const Container = styled.main`
	display: flex;
	width: 100%;
	flex-direction: column;
	padding: ${({ padded }) => padded ? '48px 24px 24px 24px' : 0};
`;
